/*
 * Styles for the /sign-up redirect page.
 *
 * index.js renders only a heading and its fallback link while forwarding to
 * the marketing product page, so these two are all that is left. The form
 * styles (StyledForm, FormButtonGroup, Agree, Demo) went with Form.js; the
 * rest (Container, ButtonGroup, ButtonWrapper, CheckboxLabel, ContactUs,
 * CheckboxWrapper, A) had already lost their last consumer before that.
 *
 * This also drops the file's `colors`, `media` and `NavLink` imports — the
 * surviving rules reference none of them.
 */

import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-top: 88px;
`;

export const Heading = styled.div`
  font-size: 16px;
  padding: ${({ email }) => (email ? '44px 0 0 0' : '0 20px 24px')};
  text-align: center;

  > a {
    color: #007aff;
    text-decoration: underline;
  }
`;
